<template>
  <div id="selectUserwrap">
    <Input  @on-clear="clear" v-model="nameHand" :clearable="clearable" :readonly='!isHand' clearable @on-change="change"
      @on-focus="focus" @on-blur="blur"><Button slot="append" icon="md-person" @click="open">
    </Button></Input>
    <div class="selectUserMy" v-show="openCarList">
      <userTree ref="userTree1" :keyword="keyword" @user="reUser" :hideSearch="true"></userTree>
    </div>
    <Drawer :placement="placement" :closable="false" v-model="openUser" draggable class="my-drawer" width="300">
      <userTree ref="userTree2" :keyword="keyword" @user="reUser"></userTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement", "keyword", "isHand", "clearable"],
  data() {
    return {
      openUser: false,
      nameHand: "",
      openCarList: false,
      timeOut: null
    };
  },
  methods: {
    open(){
      this.openUser = true;
      this.$refs.userTree2.reach(this.keyword);
      //this.$refs.userTree2.getUserTree();
    },
    reUser(v) {
      //console.log('huoquyonghu',v);
      this.openUser = false;

      this.$emit("update:id", v.id);
      this.$emit("update:account", v.account);
      this.$emit("update:accountId", v.accountId);
      this.$emit("update:name", v.name);
      this.$emit("user", v);
    },
    clear() {
      this.$emit("update:id", "");
      this.$emit("update:account", "");
      this.$emit("update:accountId", "");
      this.$emit("update:name", "");
    },
    change() {
      if (this.openCarList) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.$refs.userTree1.reach(this.nameHand);
        }, 500);
      }

    },
    focus() {
      this.openCarList = true;

      //this.$refs.userTree1.getUserTree();
      this.$refs.userTree1.reach(this.keyword);
    },
    blur() {
      //防止点击车牌选车的时候获取不到值
      setTimeout(() => {
        this.openCarList = false;
      }, 200);


    }
  },
  watch: {
    name(v) {
      this.nameHand = v;
    },
    nameHand(v) {
      this.$emit("update:name", v);
    },
  },
  mounted() {

    this.nameHand = this.name;
  },
};
</script>
<style>
.selectUserMy {
  width: 200px;
  height: 260px;
  background: #fff;
  position: absolute;
  z-index: 200;
}
</style>



// WEBPACK FOOTER //
// src/components/common/selectUser.vue